export const BASE_URL = 'https://dee-network.herokuapp.com/'